import { isReactive } from '../common-utils/signal';
import type { RenderContext } from '../render/context/createRenderContext';

export abstract class Provider {
  renderContext!: RenderContext;

  protected diposable: (() => void)[] = [];

  private _disposed = false;

  get disposed() {
    return this._disposed;
  }

  constructor() {}

  /**
   * Attach used to do some initialization work
   * @param renderContext
   */
  attach(renderContext: RenderContext): void {
    this.renderContext = renderContext;
  }

  /**
   * Activate is a little bit like attach, but in activate
   * you can reference other providers because they are already attached
   */
  activate() {}

  dispose(): void {
    Object.keys(this).forEach((key) => {
      if (isReactive(this[key])) {
        this[key].dispose();
      }
    });
    this.diposable.forEach((fn) => fn());
    this._disposed = true;
  }
}
